import { useMemo } from "react";
import { useGetProjectQuery, useGetProjectsQuery } from "./projectEndpoints";
import { Project } from "../../entities/project";
import { Ids } from "../../reducers/rhapsody";

export function useProject(ids?: Ids) {
  const projectQuery = useGetProjectQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const projectEntity = projectQuery.data;

  return useMemo(() => {
    const ret: typeof projectQuery & { project?: Project | undefined } = {
      ...projectQuery,
    };
    if (projectEntity) ret.project = new Project(projectEntity);
    return ret;
  }, [projectEntity]);
}

export function useProjects() {
  const projectQuery = useGetProjectsQuery();
  const projectEntitiesMap = projectQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof projectQuery & {
      projects?: Project[];
      projectsMap?: { [id: number]: Project };
    } = {
      ...projectQuery,
      projects: [],
      projectsMap: {},
    };
    if (projectEntitiesMap) {
      const projects: Project[] = [];
      const projectsMap: { [id: number]: Project } = {};

      for (const key in projectEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(projectEntitiesMap, key)) {
          const c = projectEntitiesMap[key];
          const project = new Project(c);
          projects.push(project);
          projectsMap[project.id] = project;
        }
      }
      projects.sort((a, b) => b.id - a.id);
      ret.projects = projects;
      ret.projectsMap = projectsMap;
    }

    return ret;
  }, [projectEntitiesMap]);
}
